export const PLAID_LINK_TOKEN_KEY = "plaid_link_token";
// Set by plaid-oauth.js (which cannot import this module — it runs before Angular
// boots) using the same literal string. Keep the two in sync.
export const PLAID_OAUTH_REDIRECT_URI_KEY = "plaid_oauth_redirect_uri";
export const ACCOUNTS_ROUTE = "/manage/accounts";
